// src/pages/Properties.js

import React, { useState,useMemo } from "react";
import { Box, Grid, Paper, Typography,Button } from "@mui/material";
import DataGridTemplate from "../../layout/datagridtable";
import TextField from '@mui/material/TextField';

const properties = [
  { id: 1, name: "Ocean View Villa", location: "Miami, FL", price: "$1,200,000" },
  { id: 2, name: "Mountain Retreat", location: "Aspen, CO", price: "$850,000" },
  { id: 3, name: "City Apartment", location: "New York, NY", price: "$950,000" },
  // Add more properties as needed
];

const Properties = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredProperties = properties.filter((property) =>
    property.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const columns = useMemo(
    () => [
      { field: "name", title: "Property Name" },
      { field: "location", title: "Location" },
      { field: "price", title: "Price" },
    ],
    []
  );

  return (
    <Box sx={{ flexGrow: 1, p: 4, backgroundColor: '#f5f7fa' }}>
      <Typography 
        variant="h4" 
        gutterBottom 
        sx={{ 
          color: '#1a237e',
          fontWeight: 'bold',
          mb: 4
        }}
      >
        Properties
      </Typography>
      <Box sx={{ 
        mb: 4,
        p: 3,
        backgroundColor: '#ffffff',
        borderRadius: 2,
        boxShadow: '0 2px 10px rgba(0,0,0,0.08)'
      }}>
        <TextField
          size="small"
          label="Search Properties"
          variant="outlined"
          value={searchTerm}
          onChange={handleSearchChange}
          sx={{ 
            mr: 2,
            '& .MuiOutlinedInput-root': {
              '&:hover fieldset': {
                borderColor: '#1976d2',
              }
            }
          }}
        />
        <Button 
          variant="contained" 
          sx={{
            background: 'linear-gradient(45deg, #1976d2 30%, #2196f3 90%)',
            boxShadow: '0 3px 5px 2px rgba(33, 150, 243, .3)',
            '&:hover': {
              background: 'linear-gradient(45deg, #1565c0 30%, #1976d2 90%)',
            }
          }}
        >
          Search
        </Button>
      </Box>
      <Grid container spacing={3}>
        {filteredProperties.map((property) => (
          <Grid item xs={12} sm={6} md={4} key={property.id}>
            <Paper sx={{ 
              p: 3,
              borderRadius: 2,
              transition: 'transform 0.2s, box-shadow 0.2s',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: '0 4px 20px rgba(0,0,0,0.12)'
              },
              background: 'linear-gradient(to bottom right, #ffffff, #f8f9fa)'
            }}>
              <Typography variant="h6" sx={{ color: '#1a237e', mb: 1 }}>
                {property.name}
              </Typography>
              <Typography sx={{ color: '#546e7a', mb: 1 }}>
                {property.location}
              </Typography>
              <Typography sx={{ 
                fontWeight: "bold", 
                color: '#2196f3',
                fontSize: '1.2rem'
              }}>
                {property.price}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
      <Box sx={{ 
        flexGrow: 1, 
        p: 3, 
        mt: 4,
        backgroundColor: '#ffffff',
        borderRadius: 2,
        boxShadow: '0 2px 10px rgba(0,0,0,0.08)'
      }}>
        <Typography 
          variant="h4" 
          gutterBottom 
          sx={{ 
            color: '#1a237e',
            fontWeight: 'bold',
            mb: 3
          }}
        >
          Properties List
        </Typography>
        <DataGridTemplate
          columns={columns}
          data={properties}
          enableRowActions={false}
          sx={{
            '& .MuiPaper-root': {
              boxShadow: 'none'
            }
          }}
        />
      </Box>
    </Box>
  );
};

export default Properties;
